export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                APP下载
              </h2>
              <p className="text-sm md:text-base text-background-300 max-w-md mx-auto lg:mx-0 mb-8 leading-relaxed">
                下载西瓜影视移动客户端，随时随地畅享高清影视。<strong className="text-accent-400">支持离线缓存、画中画播放和夜间模式</strong>，让观影更加自由便捷。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
                <a href="#app" className="group flex items-center gap-3 px-6 py-3.5 bg-background-50 rounded-xl hover:bg-background-100 transition-colors cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-apple-fill text-foreground-950 text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-[10px] text-foreground-500">下载iPhone版</p>
                    <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">App Store</p>
                  </div>
                </a>
                <a href="#app" className="group flex items-center gap-3 px-6 py-3.5 bg-background-50 rounded-xl hover:bg-background-100 transition-colors cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-android-fill text-foreground-950 text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-[10px] text-foreground-500">下载Android版</p>
                    <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">Google Play</p>
                  </div>
                </a>
                <a href="#app" className="group flex items-center gap-3 px-6 py-3.5 bg-background-50 rounded-xl hover:bg-background-100 transition-colors cursor-pointer">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-download-cloud-2-line text-foreground-950 text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-[10px] text-foreground-500">安卓APK</p>
                    <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">直接下载</p>
                  </div>
                </a>
              </div>

              <p className="text-xs text-background-500 mt-4">
                支持 iOS 15+ / Android 10+ | 版本 v3.2.0 | 48.6 MB
              </p>
            </div>

            <div className="flex-shrink-0 hidden lg:block">
              <div className="relative w-[280px]">
                <div className="aspect-[9/16] rounded-3xl overflow-hidden border-4 border-background-700">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20mobile%20movie%20streaming%20app%20interface%20mockup%20on%20phone%20screen%2C%20dark%20cinema%20theme%20with%20warm%20golden%20and%20crimson%20accents%2C%20movie%20thumbnails%20grid%20layout%2C%20clean%20minimal%20design%2C%20professional%20UI%20design%2C%20no%20recognizable%20text&width=600&height=1067&seq=app-screen-2026&orientation=portrait"
                    alt="西瓜影视APP界面预览 - 移动端高清观影"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -top-3 -right-3 w-14 h-14 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-flashlight-line text-background-950 text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}